import React from 'react'
import { Box, FormControlLabel, Grid, Stack, Switch, TextField, Typography } from '@material-ui/core'
import { LoadingButton } from '@material-ui/lab'
import Modal from 'src/components/_dashboard/blog/ProjectModel'

/**
 * Location editor for products that are only rendered inside a group row (no standalone table row),
 * so the main ViewQuotation location Modal is never mounted for them.
 */
export default function ViewQuotationGroupedProductLocationModal({
  data,
  productIndex,
  open,
  onClose,
  values,
  setSelectedProducts,
  handleAllLocationSameChange,
  setIsSaving,
  isSaving,
  LabelStyle,
}) {
  if (!data) return null
  const locations = Array.isArray(data.location) ? data.location : []

  return (
    <Modal open={open} handleClose={onClose}>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
        {data?.fromMapServices != true && (
          <FormControlLabel
            control={
              <Switch
                checked={data?.allLocationSame}
                onChange={() => handleAllLocationSameChange(productIndex)}
              />
            }
            label="All Locations Same"
          />
        )}
        {values.project_category?.id !== 14 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%', alignItems: 'center', mt: 2 }}>
            <LabelStyle sx={{ fontSize: '16px' }}>Qty Location Settings</LabelStyle>
            <Box display="flex" alignItems="center" gap={1} mt={1}>
              <Typography variant="subtitle2">Multiple</Typography>
              <Switch
                color="primary"
                checked={Boolean(data?.is_single_card)}
                onChange={(event) => {
                  const checked = event.target.checked
                  setSelectedProducts((prev) =>
                    prev.map((p) => {
                      if (p.indexId !== data.indexId) return p

                      const count = Number(p.locationQuantity || 1)

                      if (checked) {
                        return {
                          ...p,
                          is_single_card: true,
                          location: p.location?.length
                            ? [p.location[0]]
                            : [
                                {
                                  id: 0,
                                  address: '',
                                  city: '',
                                  state: '',
                                  zip: '',
                                },
                              ],
                        }
                      }
                      const allSame = p.allLocationSame
                      const firstAddress = p.location?.[0]
                      let arrayAddr = []

                      if (allSame && firstAddress) {
                        arrayAddr = Array(count)
                          .fill()
                          .map((_, i) => ({
                            ...firstAddress,
                            id: i,
                            req_loc_id: p.location[i]?.req_loc_id ?? null,
                          }))
                      } else {
                        arrayAddr = [...(p.location || [])]
                        if (arrayAddr.length < count) {
                          arrayAddr.push(
                            ...Array(count - arrayAddr.length)
                              .fill()
                              .map((_, i) => ({
                                id: arrayAddr.length + i,
                                address: '',
                                city: '',
                                state: '',
                                zip: '',
                              })),
                          )
                        } else if (arrayAddr.length > count) {
                          arrayAddr = arrayAddr.slice(0, count)
                        }
                      }

                      return {
                        ...p,
                        is_single_card: false,
                        location: arrayAddr,
                      }
                    }),
                  )
                }}
              />
              <Typography variant="subtitle2">Single</Typography>
            </Box>
          </Box>
        ) : (
          ''
        )}
      </Stack>
      <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
        {locations.map((_addr, i) => (
          <Grid item xs={12} key={`${data.indexId}-loc-${i}`}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Location {i + 1}
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="Address"
                size="small"
                value={data.location[i]?.address || ''}
                disabled={
                  (data?.fromMapServices == true && data.location[i]?.address) ? true : i !== 0 && data?.allLocationSame
                }
                onChange={(event) => {
                  setSelectedProducts((prevProducts) =>
                    prevProducts.map((p) => {
                      if (p.indexId !== data.indexId) return p
                      let updatedLocations = [...p.location]
                      if (p.allLocationSame) {
                        updatedLocations = updatedLocations.map(() => ({
                          ...updatedLocations[0],
                          address: event.target.value,
                        }))
                      } else {
                        updatedLocations[i] = {
                          ...updatedLocations[i],
                          address: event.target.value,
                        }
                      }
                      return {
                        ...p,
                        location: updatedLocations,
                      }
                    }),
                  )
                }}
              />
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="City"
                size="small"
                value={data.location[i]?.city || ''}
                disabled={
                  (data?.fromMapServices == true && data.location[i]?.city) ? true : i !== 0 && data?.allLocationSame
                }
                onChange={(event) => {
                  setSelectedProducts((prevProducts) =>
                    prevProducts.map((p) => {
                      if (p.indexId !== data.indexId) return p
                      let updatedLocations = [...p.location]
                      if (p.allLocationSame) {
                        updatedLocations = updatedLocations.map(() => ({
                          ...updatedLocations[0],
                          city: event.target.value,
                        }))
                      } else {
                        updatedLocations[i] = {
                          ...updatedLocations[i],
                          city: event.target.value,
                        }
                      }
                      return {
                        ...p,
                        location: updatedLocations,
                      }
                    }),
                  )
                }}
              />
              <TextField
                fullWidth
                label="State"
                size="small"
                value={data.location[i]?.state || ''}
                disabled={
                  (data?.fromMapServices == true && data.location[i]?.state) ? true : i !== 0 && data?.allLocationSame
                }
                onChange={(event) => {
                  setSelectedProducts((prevProducts) =>
                    prevProducts.map((p) => {
                      if (p.indexId !== data.indexId) return p
                      let updatedLocations = [...p.location]
                      if (p.allLocationSame) {
                        updatedLocations = updatedLocations.map(() => ({
                          ...updatedLocations[0],
                          state: event.target.value,
                        }))
                      } else {
                        updatedLocations[i] = {
                          ...updatedLocations[i],
                          state: event.target.value,
                        }
                      }
                      return {
                        ...p,
                        location: updatedLocations,
                      }
                    }),
                  )
                }}
              />
              <TextField
                fullWidth
                label="Zip / Postal Code"
                size="small"
                value={data.location[i]?.zip || ''}
                disabled={
                  (data?.fromMapServices == true && data.location[i]?.zip) ? true : i !== 0 && data?.allLocationSame
                }
                onChange={(event) => {
                  setSelectedProducts((prevProducts) =>
                    prevProducts.map((p) => {
                      if (p.indexId !== data.indexId) return p
                      let updatedLocations = [...p.location]
                      if (p.allLocationSame) {
                        updatedLocations = updatedLocations.map(() => ({
                          ...updatedLocations[0],
                          zip: event.target.value,
                        }))
                      } else {
                        updatedLocations[i] = {
                          ...updatedLocations[i],
                          zip: event.target.value,
                        }
                      }
                      return {
                        ...p,
                        location: updatedLocations,
                      }
                    }),
                  )
                }}
              />
            </Stack>
          </Grid>
        ))}
      </Grid>

      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={4}>
          {data?.fromMapServices == true ? (
            true
          ) : (
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
              <LoadingButton
                variant="contained"
                onClick={() => {
                  setIsSaving(true)
                  setTimeout(() => {
                    setIsSaving(false)
                    onClose()
                  }, 100)
                }}
                loading={isSaving}
              >
                {' Save '}
              </LoadingButton>
            </Box>
          )}
        </Grid>
      </Grid>
    </Modal>
  )
}
